import { FormControl } from 'native-base'
import { forwardRef } from 'react'
import { TextInput } from 'react-native'

import { Input as BaseInput } from '../../atoms/Input'
import { layoutPropsKeys } from './constants'
import type { FieldInputProps } from './types'

import { useMemo } from '~hooks'

export const Input = forwardRef<TextInput, FieldInputProps>(
  ({ errorMessage, helperText, isInvalid, isRequired, label, ...props }, ref) => {
    const layoutProps = useMemo(
      () =>
        Object.fromEntries(Object.entries(props).filter(([key]) => layoutPropsKeys.includes(key))),
      [props]
    )
    const inputProps = useMemo(
      () =>
        Object.fromEntries(Object.entries(props).filter(([key]) => !layoutPropsKeys.includes(key))),
      [props]
    )

    return (
      <FormControl isRequired={isRequired} isInvalid={isInvalid} {...layoutProps}>
        {label && (
          <FormControl.Label
            _text={{
              fontSize: 'sm',
              fontWeight: '600',
              color: 'gray.700',
              mb: 2,
            }}
          >
            {label}
          </FormControl.Label>
        )}
        <BaseInput isError={Boolean(errorMessage)} {...inputProps} ref={ref} />
        {helperText && (
          <FormControl.HelperText
            _text={{
              fontSize: 'xs',
              color: 'gray.500',
              mt: 1,
            }}
          >
            {helperText}
          </FormControl.HelperText>
        )}
        <FormControl.ErrorMessage
          _text={{
            fontSize: 'xs',
            color: 'error.600',
            fontWeight: '500',
            mt: 1,
          }}
        >
          {errorMessage || ' '}
        </FormControl.ErrorMessage>
      </FormControl>
    )
  }
)
